import _debounce from 'lodash/debounce';
import { transformControls } from 'src/service/scene/scene-nodes/TransformControls/data';
import { MpSdk } from 'src/types';
import { NodeEventsTypes } from '../../enums';
import Scene from '../../scene';

class TransformControls extends Scene {
  control: any;

  constructor(mpSDK: MpSdk) {
    super(mpSDK);
    // @ts-ignore
    mpSDK.Mode.current.subscribe((mode) => {
      if (mode === mpSDK.Mode?.Mode.FLOORPLAN) {
        this.control.inputs.size = 0.025;
        this.control.inputs.showY = false;
      } else {
        this.control.inputs.size = 1;
        this.control.inputs.showY = true;
      }
    });
  }

  async create() {
    const node = await this.scene.createNode();
    this.control = node.addComponent(transformControls);
    node.start();

    // this.control.inputs.visible = false;
    this.control.outputs.objectRoot.addEventListener(
      'change',
      _debounce(() => {
        this.emit(NodeEventsTypes.TRANSFORM_CONTROL_CHANGED);
      }, 500),
    );
  }
}

export default TransformControls;
